export default function filterAdvanced() {
    const toggleButton = document.querySelector(".js-advanced-filter-toggle");
    const advancedContent = document.querySelector(".js-advanced-filter-content");

    if (toggleButton && advancedContent) {
        toggleButton.addEventListener("click", () => {
            const isActive = advancedContent.classList.toggle("is-active");
            
            const showText = toggleButton.getAttribute("data-text-show");
            const hideText = toggleButton.getAttribute("data-text-hide");
            
            toggleButton.textContent = isActive ? hideText : showText;
        });
    }

    const orderSelect = document.querySelector(".js-order-select");
    const orderTagText = document.querySelector(".js-order-tag-text");

    if (orderSelect && orderTagText) {
        orderSelect.addEventListener("change", (e) => {
            const selectedOption = e.target.options[e.target.selectedIndex];
            orderTagText.textContent = selectedOption.text;
        });
    }
}
